export default __webpack_public_path__ + "static/media/btnSearch.85e7d2fd.svg";